import * as types from 'stores/types/';

export function toggleQuickViewTab1() {
  return { type: types.TOGGLE_QUICK_VIEW_TAB_1 };
}

export function toggleQuickViewTab2() {
  return { type: types.TOGGLE_QUICK_VIEW_TAB_2 };
}

export function closeQuickView() {
  return { type: types.CLOSE_QUICK_VIEW };
}



// WEBPACK FOOTER //
// ./stores/actions/operator/dashboard.js